import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';





// RG styles for the frontend-base site. The classic MFEs pull the chrome in from their own
// `index.scss`, which the site has no equivalent of; imported here they land in the `site` cascade
// layer, after the shell's. The footer's entry point is a Sass partial, hence the underscore.
import './src/rg-site.css';
import './src/apps/instructor-dashboard.css';

import '@edx/frontend-component-header/dist-fb/index.scss';
import '@edx/frontend-component-footer/dist-fb/_footer.scss';

// Keep the light/dark choice in sync with the legacy LMS/Studio pages, across tabs and origins.
// Same idea as the classic bridge in `mfe-env-config-buildtime-definitions`, but frontend-base stores
// the variant under its own localStorage key and html attribute, so the two cannot share one file.
// Top-level module code, so it runs before frontend-base reads the persisted variant.
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') { return; }

  var COOKIE_NAME = 'theme-variant';              // legacy cross-origin cookie
  var LS_KEY = 'selected-theme-variant';          // frontend-base's variant store
  var HTML_ATTR = 'data-theme-variant';           // attribute frontend-base sets

  function isVariant(v) { return v === 'dark' || v === 'light'; }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // 1) legacy -> site: adopt the cookie variant before frontend-base reads localStorage.
  try {
    var cookieVariant = readCookie(COOKIE_NAME);
    if (isVariant(cookieVariant) && window.localStorage.getItem(LS_KEY) !== cookieVariant) {
      window.localStorage.setItem(LS_KEY, cookieVariant);
    }
  } catch (e) { /* localStorage unavailable (private mode / blocked) */ }

  // Derived rather than read from `THEME_COOKIE_DOMAIN`: the runtime config is not fetched yet. The
  // site is served from `apps.<LMS_HOST>`, so the shared parent is the host minus its first label.
  function cookieDomain() {
    return '.' + window.location.hostname.replace(/^[^.]+\./, '');
  }

  // 2) site -> legacy: mirror the html attribute frontend-base sets into the shared cookie.
  function mirrorVariantToCookie() {
    var variant = document.documentElement.getAttribute(HTML_ATTR);
    if (!isVariant(variant) || readCookie(COOKIE_NAME) === variant) { return; }
    document.cookie = COOKIE_NAME + '=' + variant + '; path=/; domain=' + cookieDomain()
      + '; max-age=31536000; samesite=lax'
      + (window.location.protocol === 'https:' ? '; secure' : '');
  }

  try {
    // Attach before React renders so the very first variant frontend-base applies is mirrored too.
    new MutationObserver(mirrorVariantToCookie).observe(document.documentElement, {
      attributes: true,
      attributeFilter: [HTML_ATTR],
    });
  } catch (e) { /* MutationObserver unavailable */ }
})();


import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "Academy - Reddin AI",
  baseUrl: 'https://apps.academy.reddin.ai',
  cmsBaseUrl: 'https://studio.academy.reddin.ai',
  lmsBaseUrl: 'https://academy.reddin.ai',
  loginUrl: 'https://academy.reddin.ai/login',
  logoutUrl: 'https://academy.reddin.ai/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);





export default siteConfig;